import { GridSortModel } from '@mui/x-data-grid';
import { toSinglePascalCase } from './casing';

const sortModelToString = (model: GridSortModel) =>
    model.length > 0 ? `${toSinglePascalCase(model[0].field)} ${model[0].sort}` : undefined;

export function orderBy(sortModel: GridSortModel, fallbackModel: GridSortModel = []) {
    return sortModelToString(sortModel) ?? sortModelToString(fallbackModel);
}
